import { useState, useCallback } from 'react';

export function useWebhook() {
  const [webhookUrl, setWebhookUrlState] = useState(() => {
    return localStorage.getItem('resumeProWebhookUrl') || '';
  });

  const setWebhookUrl = useCallback((newUrl: string) => {
    setWebhookUrlState(newUrl);
    localStorage.setItem('resumeProWebhookUrl', newUrl);
  }, []);

  const fireWebhook = async (action: string, payload: any) => {
    if (!webhookUrl) return;
    try {
      await fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action,
          timestamp: new Date().toISOString(),
          data: payload,
          source: 'ResumePro CRM'
        }),
      });
    } catch (err) {}
  };

  return { webhookUrl, setWebhookUrl, fireWebhook };
}
